import { useEffect } from "react";
import { useLocation } from "react-router";

import { initMixpanel, trackEvent } from "@/lib/mixpanel";
import { ROUTE_PAGE_NAMES } from "@/utils/constants";

export const RouteAnalytics = () => {
  const pathname = useLocation().pathname;

  useEffect(() => {
    initMixpanel();
  }, []);

  useEffect(() => {
    const pageName =
      ROUTE_PAGE_NAMES[pathname ?? ""] || pathname?.replace("/", "") || "homepage";
    trackEvent("Page Viewed", {
      page_name: pageName,
    });
  }, [pathname]);

  return null;
};
